import {VueCookieNext} from "vue-cookie-next";
import {v4 as uuidv4} from "uuid";

import CookieNames from "../enums/CookieNames";

VueCookieNext.config({
  domain: window.lingokingConfig.URL_FQDN,
  expire: '60d'
})

class CookieService {
  getCookie(cookieName) {
    return VueCookieNext.getCookie(getCookieNameWithHash(cookieName))
  }

  setCookie(cookieName, value, options = null) {
    VueCookieNext.setCookie(getCookieNameWithHash(cookieName), value, options)
  }

  removeCookie(cookieName) {
    VueCookieNext.removeCookie(getCookieNameWithHash(cookieName))
  }

  // `tokenName` is the calling app's session-token cookie (see TokenService.getTokenName()).
  // It is passed in rather than read from TokenService, which already imports this module.
  // Only apps on the default token (customer-area/backoffice) own PM impersonation, so only they
  // may clear `X-Switch-User`; an app with its own token name (lsp-new) must leave it alone.
  removeAuthCookies(tokenName = CookieNames.LK_TOKEN) {
    let authCookies = [tokenName]

    if (tokenName === CookieNames.LK_TOKEN) {
      authCookies.push(CookieNames.SWITCH_USER)
    }

    authCookies.forEach(cookie => VueCookieNext.removeCookie(getCookieNameWithHash(cookie)))
  }

  // Cookies live on the shared apex domain, so clear only the calling app's own cookies — never
  // another app's session or third-party cookies (consent, lang, analytics, support chat).
  // The cart and impersonation cookies belong to the default-token apps (customer-area/backoffice);
  // an app with its own token name (lsp-new) must not clear them, or its logout would drop the
  // customer's `cart-id` on the apex domain.
  removeAllCookies(removeLogin = true, tokenName = CookieNames.LK_TOKEN) {
    let dataCookies = []

    if (tokenName === CookieNames.LK_TOKEN) {
      dataCookies.push(CookieNames.CART_ID, CookieNames.SWITCH_USER)
    }

    dataCookies.forEach(cookie => VueCookieNext.removeCookie(getCookieNameWithHash(cookie)))

    if (removeLogin) {
      VueCookieNext.removeCookie(getCookieNameWithHash(tokenName))
    }
  }

  getSwitchUser() {
    return this.getCookie(CookieNames.SWITCH_USER)
  }

  setSwitchUser(email) {
    this.setCookie(CookieNames.SWITCH_USER, email)
  }

  removeSwitchUser() {
    this.removeCookie(CookieNames.SWITCH_USER)
  }

  getCartId() {
    return this.getCookie(CookieNames.CART_ID)
  }

  setCartId(id = null) {
    if (!id) {
      id = uuidv4()
    }

    const anonymousCartCookie = this.getCartId()

    if (!anonymousCartCookie) {
      this.setCookie(CookieNames.CART_ID, id, {expire: 0, secure: true})
    }

    return this.getCartId()
  }

  removeCartId() {
    this.removeCookie(CookieNames.CART_ID)
  }
}

function getCookieNameWithHash(cookieName) {
  return cookieName + '-' + window.lingokingConfig.MM_ENVIRONMENT
}

export default new CookieService();
